import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n/i18n";
import { LangSwitcher } from "@/components/i18n/LangSwitcher";

export const UpvMark = ({ inverted = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-upv-mark">
    <span className={`font-display text-2xl font-extrabold leading-none tracking-tight ${inverted ? "text-white" : "text-upv"}`}>UPV</span>
    <span className={`h-7 w-px ${inverted ? "bg-white/30" : "bg-slate-300"}`} />
    <span className={`max-w-[150px] text-[11px] font-medium leading-tight ${inverted ? "text-white/70" : "text-slate-500"}`}>
      Universitat Politècnica de València
    </span>
  </div>
);

export const ProductMark = ({ inverted = false }) => (
  <span className={`font-display text-sm font-semibold uppercase tracking-[0.18em] ${inverted ? "text-white/80" : "text-slate-900"}`}>
    Career Fair <span className="text-upv">·</span> 2027
  </span>
);

export const DoItSignature = ({ inverted = false, className = "" }) => (
  <p className={`text-[11px] tracking-wide ${inverted ? "text-white/45" : "text-slate-400"} ${className}`} data-testid="doit-signature">
    Technology by <span className={`font-semibold ${inverted ? "text-white/70" : "text-slate-600"}`}>Do IT Happen</span>
  </p>
);

export const SiteHeader = ({ right = null }) => (
  <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl" data-testid="site-header">
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 lg:px-10">
      <Link to="/" data-testid="header-home-link"><UpvMark /></Link>
      <div className="flex items-center gap-4">
        <span className="hidden md:inline"><ProductMark /></span>
        <LangSwitcher testPrefix="header-lang" className="hidden sm:flex" />
        {right}
      </div>
    </div>
  </header>
);

export const PageFooter = () => {
  const { t } = useI18n();
  return (
  <footer className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-10 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between lg:px-10">
    <span>{t("Foro de Empleo UPV 2027")} · {t("Prototipo de demostración")}</span>
    <DoItSignature />
  </footer>
  );
};
